
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 2a6 6 0 100 12A6 6 0 008 2zM.667 8a7.333 7.333 0 1114.666 0A7.333 7.333 0 01.667 8z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.667 8c0-.369.298-.667.666-.667h13.334a.667.667 0 010 1.333H1.333a.667.667 0 01-.666-.667z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 8a9.533 9.533 0 002 5.632A9.533 9.533 0 0010 8a9.533 9.533 0 00-2-5.632 9.533 9.533 0 00-2 5.632zm2-6.667l-.492-.45a10.867 10.867 0 00-2.841 7.13 10.867 10.867 0 002.84 7.103.667.667 0 00.985 0 10.867 10.867 0 002.841-7.13A10.867 10.867 0 008.493.882L8 1.333z"}})])
          )
        }
      }
    